import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Star, Quote } from "lucide-react";

export default function Reviews() {
  const { t } = useLanguage();
  const items = t("reviews.items");

  return (
    <section id="reviews" data-testid="reviews-section" className="relative bg-[#F9F6F0] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <span className="text-[12px] uppercase tracking-[0.22em] text-[#C05A3A] font-medium">
              {t("reviews.eyebrow")}
            </span>
            <h2 className="font-serif-display text-[#232321] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] mt-4">
              {t("reviews.title")}
            </h2>

            <div className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#EADCCF] border border-[#E2D9CD] px-4 py-2.5">
              <div className="flex items-center gap-0.5 text-[#C05A3A]">
                {[...Array(5)].map((_, i) => (
                  // eslint-disable-next-line react/no-array-index-key -- static 5-star array, never reorders
                  <Star key={i} className="h-4 w-4 fill-current" strokeWidth={0} />
                ))}
              </div>
              <span className="text-[13px] font-medium text-[#232321]">
                {t("reviews.googleRating")}
              </span>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-6">
            {items.map((r, i) => (
              <article
                key={r.name}
                data-testid={`review-card-${i}`}
                className="relative bg-[#EADCCF] border border-[#E2D9CD] rounded-2xl p-7 md:p-9"
              >
                <Quote className="absolute top-6 right-6 h-7 w-7 text-[#C05A3A]/30" strokeWidth={1.5} />
                <div className="flex items-center gap-0.5 text-[#C05A3A] mb-4">
                  {[...Array(5)].map((_, k) => (
                    // eslint-disable-next-line react/no-array-index-key -- static 5-star array, never reorders
                    <Star key={k} className="h-4 w-4 fill-current" strokeWidth={0} />
                  ))}
                </div>
                <p className="font-serif-display italic text-[#232321] text-xl md:text-2xl leading-snug">
                  “{r.quote}”
                </p>
                <div className="mt-5 text-[12px] uppercase tracking-[0.22em] text-[#5C5C59]">
                  — {r.name}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
